/* =============================================================
   FREE GIFT GLOBAL (V11 - Native Gray Badge Style)
   - Maneja el botón "Add".
   - Inyecta el Label "FREE GIFT" con el estilo nativo (gris + ícono bolsa).
   - Bloquea los controles de cantidad.
   ============================================================= */

document.addEventListener('DOMContentLoaded', () => {
  const getSettings = () => window.fgGlobal || { giftIds: [], threshold: 6900 };

// 🔒 Flag global: solo permitir 1 proceso de "add gift" a la vez
  let fgGiftAddInProgress = false; // NUEVO

  // --- UI HELPER: MODAL ---
  function createModalHTML() {
    if (document.querySelector('.fg-modal-overlay')) return;
    document.body.insertAdjacentHTML('beforeend', `
      <div class="fg-modal-overlay" id="fg-modal">
        <div class="fg-modal-box">
          <button class="fg-modal-close-icon">&times;</button>
          <div class="fg-modal-icon">🍬</div>
          <h3 class="fg-modal-title">Notice</h3>
          <p class="fg-modal-message" id="fg-modal-text"></p>
          <button class="fg-modal-btn">Got it</button>
        </div>
      </div>`);
    const m = document.getElementById('fg-modal');
    const close = () => m.classList.remove('is-visible');
    m.querySelectorAll('button').forEach(b => b.addEventListener('click', close));
    m.addEventListener('click', (e) => { if(e.target === m) close() });
  }

  function showCustomAlert(message, autoCloseMs = 3000) {
    createModalHTML();
    const m = document.getElementById('fg-modal');
    document.getElementById('fg-modal-text').innerHTML = message;
    m.classList.add('is-visible');
    if (autoCloseMs) setTimeout(() => m.classList.remove('is-visible'), autoCloseMs);
  }

  // --- LISTENER: ALERTA DESDE CART-ITEMS.JS ---
  document.addEventListener('fg:gift-removed-alert', (e) => {
    const threshold = e.detail?.threshold || 6900;
    showCustomAlert(
      `Cart total dropped below <b>$${(threshold/100).toFixed(2)}</b>.<br>The free gift was removed.`, 
      3500
    );
  });

  // --- LOGICA BOTÓN "AGREGAR" (Get Gift Button) ---
  async function handleAddGift(btn) {
    // 🔒 Bloqueo GLOBAL: si ya hay un gift en proceso, no hacer nada
    if (fgGiftAddInProgress) return;
    fgGiftAddInProgress = true;

    // 🔒 Evitar doble click / múltiples llamadas simultáneas en ESTE botón
    if (btn.classList.contains('fg-is-busy')) {
      fgGiftAddInProgress = false; // 👈 MUY IMPORTANTE: liberar el flag global si salimos aquí
      return;
    }
    btn.classList.add('fg-is-busy');
    
    const { giftIds, threshold } = getSettings();
    const variantId = btn.dataset.variantId;
    const minThreshold = threshold || 6900;
    const originalText = btn.innerText;

    btn.innerText = '...';
    btn.style.opacity = '0.7';
    btn.disabled = true;               // NUEVO
    btn.style.pointerEvents = 'none';  // NUEVO

    try {
      const res = await fetch(`/cart.js?v=${Date.now()}`);
      const cart = await res.json();

      if (cart.items_subtotal_price < minThreshold) {
        const diff = minThreshold - cart.items_subtotal_price;
        showCustomAlert(`Spend <b>$${(minThreshold/100).toFixed(2)}</b> to unlock.<br>Add <b>$${(diff/100).toFixed(2)}</b> more!`, 4000);
        throw new Error('Low subtotal');
      }

      if (cart.items.some(i => giftIds.includes(String(i.variant_id)))) {
        showCustomAlert('You already have a free gift.', 3000);
        throw new Error('Exists');
      }

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          id: variantId, 
          quantity: 1,
          properties: { '_type': 'Free Gift' }
        })
      });

      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { 
        bubbles: true, 
        detail: { opener: btn } 
      }));

      setTimeout(() => {
        const icon = document.querySelector('.header__icon--cart') || document.getElementById('cart-icon');
        if (icon) icon.click();
      }, 500);

    } catch (e) {
    } finally {
      btn.innerText = originalText;
      btn.style.opacity = '1';
      
      // 🔓 Liberar bloqueo y reactivar botón
      btn.classList.remove('fg-is-busy'); // NUEVO
      btn.disabled = false;               // NUEVO
      btn.style.pointerEvents = '';       // NUEVO

      fgGiftAddInProgress = false;        // NUEVO: liberar el bloqueo GLOBAL
    
    }
  }

  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('.free-gift-add');
    if (btn) {
      e.preventDefault();
      handleAddGift(btn);
    }
  });
  
  // --- UI ENFORCER: BLOQUEO + LABEL NATIVO ---
  const enforceGiftUI = () => {
     const { giftIds } = getSettings();
     const cartRows = document.querySelectorAll('.cart-item, tr.cart-item');

     cartRows.forEach(row => {
       const vId = String(row.dataset.variantId);
       
       if(giftIds.includes(vId)) {
         // 1. Bloquear controles
         const plusBtn = row.querySelector('button[name="plus"]');
         if(plusBtn) { 
           plusBtn.disabled = true; 
           plusBtn.style.pointerEvents='none'; 
           plusBtn.style.opacity='0.2'; 
         }
         const input = row.querySelector('input[name="updates[]"]');
         if(input) input.readOnly = true;

         // 2. INYECTAR LABEL (Estilo Nativo Gris)
         const container = row.querySelector('.cart-item__details, .cart-item__name-container, .product-option') || row.querySelector('a');
         
         if (container && !row.querySelector('.fg-badge-label')) {
           const badge = document.createElement('div');
           badge.className = 'fg-badge-label';
           
           // Ícono SVG de bolsa + Texto
           badge.innerHTML = `
             <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
             FREE GIFT
           `;
           
           // Estilos en CSS (.fg-badge-label en cart-drawer-redesign.css / cart-items.css).
           // El drawer ya renderiza el badge desde Liquid; esto cubre la página del carrito.

           container.appendChild(badge);
         }
       }
     });
  };
  
  document.addEventListener('cart:updated', enforceGiftUI); 
  document.addEventListener('dispatch:cart-drawer:refresh', () => setTimeout(enforceGiftUI, 500));
  new MutationObserver(enforceGiftUI).observe(document.body, {childList: true, subtree: true});
});